import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from './translations';

const DEFAULT_LANGUAGE = 'en';
const STORAGE_KEY = 'website-language';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
    return translations[savedLanguage] ? savedLanguage : DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      languages: Object.values(translations).map(({ code, label, shortLabel }) => ({
        code,
        label,
        shortLabel
      })),
      t: translations[language] || translations[DEFAULT_LANGUAGE]
    }),
    [language]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used inside LanguageProvider');
  }

  return context;
}
